// @flow
import React from 'react';
import { css } from 'react-emotion';
import { components } from '@peachjar/components';

import DownloadButtonsSection from '../components/DownloadButtonsSection';
import UploadSectionWrapper from '../components/UploadSectionWrapper';

const { NumberedRow } = components;

type Props = {
  isUploading: boolean,
  uploadingErrors: Array<any>,
  uploadingPercentage: number,
  totalUploaded: number,
  isUploadComplete: boolean,
  uploadingFilename: string,
  setParentUploadingFile: () => void,
  ncesSchoolId: number,
  parentUploadingInstructionsClicked: boolean,
  parentUploadingTemplateCLicked: boolean,
  handleParentInstructionsClick: boolean,
  handleParentCsvClick: () => void,
  parentUploadTaskId: string,
  haveParentsBeenLoaded: boolean,
  handleParentCsvUploadStatusComplete: (bool: boolean) => void,
  handleParentCsvHasErrors: (bool: boolean) => void,
  handleTabView: (tab: number) => void,
};

const getStatus = (isUploading, isUploadComplete, uploadingErrors) => {
  if (isUploading) return 'running';
  if (isUploadComplete && uploadingErrors.length === 0) return 'completed';
  if (isUploadComplete && uploadingErrors.length > 0) return 'error';
  return 'pending';
}

const UploadParents = ({
  isUploading,
  uploadingErrors,
  uploadingPercentage,
  totalUploaded,
  isUploadComplete,
  uploadingFilename,
  setParentUploadingFile,
  ncesSchoolId,
  parentUploadingInstructionsClicked,
  parentUploadingTemplateCLicked,
  handleParentInstructionsClick,
  handleParentCsvClick,
  haveParentsBeenLoaded,
  handleTabView,
}: Props) => (
  <div className={styles.uploadWrapper}>
    <NumberedRow rowNumber={1} headerText="Prepare CSV File">
      <DownloadButtonsSection
        handleInstructionsDownload={handleParentInstructionsClick}
        handleCsvTemplateDownload={handleParentCsvClick}
        showCsvTemplateButton={
          haveParentsBeenLoaded || parentUploadingInstructionsClicked
        }
        ncesSchoolId={ncesSchoolId}
      />
    </NumberedRow>
    <UploadSectionWrapper
        parentUploadingInstructionsClicked={parentUploadingInstructionsClicked}
        parentUploadingTemplateCLicked={parentUploadingTemplateCLicked}
        setParentUploadingFile={setParentUploadingFile}
        haveParentsBeenLoaded={haveParentsBeenLoaded}
        handleTabView={handleTabView}
        graphqlLoading={false}
        isUploadComplete={isUploadComplete}
        isUploading={isUploading}
        status={getStatus(isUploading, isUploadComplete, uploadingErrors)}
        totalCount={totalUploaded}
        uploadingPercentage={uploadingPercentage}
        uploadingFilename={uploadingFilename}
        validationErrors={uploadingErrors}
      />
  </div>
);

export default UploadParents;

const styles = {
  continueButton: css`
    margin-right: 0;
  `,
  uploadWrapper: css`
    background-color: white;
    padding: 4rem 3rem;
    border-radius: 3px;
  `,
  numberedRowWrapper: css`
    margin-top: 64px;
    & > * {
      margin-bottom: 57px;
    }
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/containers/UploadParentsTab.jsx